import React from "react";
import { Checkbox, FormControlLabel, FormControl } from "@mui/material";

const CheckboxInput = ({ label, name, checked, onChange, required }) => {
  return (
    <FormControl required={required} sx={{ paddingLeft: 10, paddingTop: 3 }}>
      <FormControlLabel
        control={
          <Checkbox
            name={name}
            checked={checked}
            onChange={(e) =>
              onChange({
                target: {
                  name,
                  value: e.target.checked,
                },
              })
            }
          />
        }
        label={label}
      />
    </FormControl>
  );
};

export default CheckboxInput;
